// Central, non-hardcoded configuration for bulk calendar operations.
// Everything that governs bulk safety lives here (never inside UI components),
// so limits can be tuned in one place. Defaults are safe and documented.

export const BULK_CONFIG = {
  // Maximum concrete events one approved bulk job may create.
  maxEventsPerJob: 1000,
  // Events written per batch (single localStorage write per batch, then the
  // existing debounced cloud snapshot sync persists them to the backend).
  batchSize: 50,
  // Maximum span a single recurrence/date range may cover (guards runaway expansion).
  maxDateRangeDays: 800,
  // How many bulk jobs a user may have actively processing at once.
  maxConcurrentJobsPerUser: 1,
  // Maximum AI chunks accepted when assembling a chunked (non-recurring) draft.
  maxChunksPerProposal: 40,
  // A chunked draft older than this (ms) is considered expired and discarded.
  chunkExpiryMs: 30 * 60 * 1000,
  // How many events the compact card previews before pagination.
  previewCount: 15,
  // Page size for the "Review details" paginated / virtualized list.
  reviewPageSize: 25,
};

// A proposal is treated as "bulk" (routed to the bulk pipeline) once it would
// create at least this many events. Smaller create-sets keep the classic flow.
export const BULK_THRESHOLD = 30;
